import { render, staticRenderFns } from "./zhipaiwuhuoCYS.vue?vue&type=template&id=b82cafd0&scoped=true&"
import script from "./zhipaiwuhuoCYS.vue?vue&type=script&lang=js&"
export * from "./zhipaiwuhuoCYS.vue?vue&type=script&lang=js&"
import style0 from "./zhipaiwuhuoCYS.vue?vue&type=style&index=0&id=b82cafd0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82cafd0",
  null
  
)

export default component.exports